import { useRef, useState } from "react";
import {
    infCTesInterface,
    infUnidTranspInterface,
    SelectObjectRemoveInterface
} from "../../../../interfaces";
import { formatMoeda, getUuidV4, goToFocus } from "../../../../utils/utils";
import { JConfirmDelete, JRow, MensagemModal } from "../../../../components/Components";
import { Button, Col, Form, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { TypeUnidadeTransporte } from "../../../../lists";
import CTesUnidadeTranspInfLacreCarga from "./CTesUnidadeTranspInfLacreCarga";

interface formProps {
    notaFiscal: infCTesInterface;
    setNotaFiscal: React.Dispatch<React.SetStateAction<infCTesInterface>>
}

const initialForm: infUnidTranspInterface = {
    id: 0,
    idunidtransp: '',
    qtdrat: 0,
    tpunidtransp: 1,
    lacUnidTransp: [],
    infUnidCarga: []
}

const initialSelect: SelectObjectRemoveInterface = {
    id: 0,
    title: ''
}

const CTesUnidadeTransp: React.FC<formProps> = ({ notaFiscal, setNotaFiscal }) => {
    const [selected, setSelected] = useState<SelectObjectRemoveInterface>(initialSelect);
    const [form, setForm] = useState<infUnidTranspInterface>(initialForm);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [messageAlert, setMessageAlert] = useState<string>('');
    const [idItem, setIdItem] = useState<number | string>(0);
    const [showItem, setShowItem] = useState<boolean>(false);
    const idunidtranspRef = useRef<HTMLInputElement>(null)

    const alerta = (message: string) => {
        setMessageAlert(message);
        setShowAlert(true)
    }

    const handleShowItem = (id: number | string) => {
        setIdItem(id);
        setShowItem(true);
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(initialSelect);
    }

    const handleOpenModal = (value: SelectObjectRemoveInterface) => {
        setSelected(value);
        setShowModal(true);
    }

    const validaPreenchimento = () => {
        if (form.idunidtransp.trim() === "") {
            alerta('Informe o Identificador da unidade de transporte.');
            goToFocus(idunidtranspRef);
            return false;
        }

        if (notaFiscal.chCTe.trim() === "") {
            alerta('Informe a chave da CT-e.');
            return false;
        }

        return true;
    }

    const handleChange = (e: any) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
    }

    const handleAdd = () => {
        if (validaPreenchimento()) {
            setNotaFiscal({
                ...notaFiscal,
                infUnidTransp: [...(notaFiscal.infUnidTransp || []), {
                    ...form,
                    id: getUuidV4(),
                    lacUnidTransp: [],
                    infUnidCarga: []
                }]
            })
            setForm(initialForm);
            goToFocus(idunidtranspRef);
        }
    }

    const handleRemover = (id: number) => {
        if ((notaFiscal.infUnidTransp?.length || 0) > 0) {
            setNotaFiscal({
                ...notaFiscal,
                infUnidTransp: notaFiscal.infUnidTransp?.filter((item: infUnidTranspInterface) => item.id !== id)
            })
        }
        setShowModal(false);
    }

    return (<>
        <JRow className="mb-3">
            <Col md>
                <Form.Group>
                    <Form.Label>Tipo Unid. Transp.</Form.Label>
                    <Form.Select name="tpunidtransp" onChange={handleChange} value={form.tpunidtransp}>
                        {TypeUnidadeTransporte.map(x => (
                            <option key={x.id} value={x.id}>{x.name}</option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </Col>

            <Col md>
                <Form.Group>
                    <Form.Label>* Identificação</Form.Label>
                    <Form.Control type="text" name="idunidtransp" maxLength={20} value={form.idunidtransp}
                        ref={idunidtranspRef}
                        onChange={handleChange} />
                </Form.Group>
            </Col>

            <Col md>
                <Form.Group>
                    <Form.Label>Rateio</Form.Label>
                    <Form.Control type="number" name="qtdrat" min={0} value={form.qtdrat}
                        onChange={handleChange} />
                </Form.Group>
            </Col>

            <Col md={'auto'} className="d-flex align-items-end">
                <Button variant="primary" onClick={handleAdd} >
                    <FontAwesomeIcon icon={faPlus} /> Adicionar
                </Button>
            </Col>

        </JRow>

        <Table striped bordered hover size="sm" responsive>
            <thead className="table-light">
                <tr>
                    <th className="text-center" style={{ width: '4.5rem' }}>#</th>
                    <th>Tipo Unid. Carga</th>
                    <th>Identificador</th>
                    <th>Qtd. Rateio</th>
                </tr>
            </thead>
            <tbody>

                {notaFiscal.infUnidTransp?.map((item: infUnidTranspInterface) => {
                    return (
                        <tr key={item.id} >
                            <td className="text-center d-flex justify-content-around">
                                <Link to={''} className="text-danger"
                                    onClick={() =>
                                        handleOpenModal({ id: item.id, title: item.idunidtransp })
                                    }
                                >
                                    <FontAwesomeIcon icon={faTrash} />
                                </Link>

                                <Link to={''} className="text-success"
                                    title="Lacres e Unidade de carga"
                                    onClick={() => handleShowItem(item.id)}
                                >
                                    <FontAwesomeIcon icon={faEye} />
                                </Link>

                            </td>
                            <td>
                                {TypeUnidadeTransporte.find((i) => (
                                    i.id.toString() === item.tpunidtransp.toString()
                                ))?.name
                                }
                            </td>
                            <td>{item.idunidtransp}</td>
                            <td>{formatMoeda(item.qtdrat, 3)}</td>
                        </tr>
                    )
                })}

            </tbody>
        </Table>

        <CTesUnidadeTranspInfLacreCarga
            show={showItem}
            notaFiscal={notaFiscal}
            setNotaFiscal={setNotaFiscal}
            id={idItem}
            handleClose={() => setShowItem(false)}
        />

        <JConfirmDelete
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            handleDelete={handleRemover}
            selectedObject={selected.title}
            id={selected.id}
        />

        <MensagemModal
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            mensagem={messageAlert}
        />
    </>)
}

export default CTesUnidadeTransp;